/* global axios */
import ApiClient from './ApiClient';

class AiSkillsAPI extends ApiClient {
  constructor() {
    super('ai/skills', { accountScoped: true, apiVersion: 'v2' });
  }
}

export default new AiSkillsAPI();
